import { GameDataContext } from 'contexts/game-data.context';
import { MlbSportId } from 'lib_ts/enums/mlb-stats-api/base.enum';
import { useContext, useMemo } from 'react';
import useMiscStore from 'stores/use-misc-store';

const LOGO_FALLBACK = true;

export const GameDataTeamLogo = (props: {
  // e.g. 48px
  size: string;
  teamPK: number | undefined;
  name?: string;
}) => {
  const { filterGlobal } = useContext(GameDataContext);
  const isDarkMode = useMiscStore((s) => s.isDarkMode);

  const url = useMemo(() => {
    if (!props.teamPK) {
      if (!LOGO_FALLBACK) {
        // don't draw anything
        return '';
      }

      switch (filterGlobal.sportId) {
        case MlbSportId.AAA: {
          return '/img/milb-logo-square.svg';
        }

        case MlbSportId.MLB: {
          return '/img/mlb-logo-square.svg';
        }

        default: {
          return '';
        }
      }
    }

    if (filterGlobal.sportId !== MlbSportId.MLB) {
      // non-MLB teams don't have different logos for light and dark bg
      return `https://www.mlbstatic.com/team-logos/${props.teamPK}.svg`;
    }

    const base = isDarkMode
      ? 'https://www.mlbstatic.com/team-logos/team-cap-on-dark/'
      : 'https://www.mlbstatic.com/team-logos/team-cap-on-light/';

    return base + `${props.teamPK}.svg`;
  }, [props.teamPK, isDarkMode, filterGlobal.sportId]);

  if (!url) {
    return null;
  }

  return (
    <img
      loading="lazy"
      height={props.size}
      width={props.size}
      alt={props.name ?? 'no team'}
      src={url}
    />
  );
};
